function a(r) {
  var e = r[0], n = r.slice(1);
  return {
    method: e,
    resolve: function() {
    },
    reject: console.error,
    args: n,
    called: !1
  };
}
var t = function(r) {
  return r.map(a);
}, o = function() {
  var r = window.analytics;
  if (!Array.isArray(r))
    return [];
  var e = r.splice(0, r.length);
  return t(e);
};
export {
  o as popSnippetWindowBuffer,
  a as transformSnippetCall
};
//# sourceMappingURL=index40.js.map
